import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useDropdown } from "src/hooks/useDropdown.hook";
import { useAuth } from "src/hooks/useAuth.hook";

const CompanyEnableFeatures = ({
  getFieldProps,
  values,
  setFieldValue,
  isCreateCompany,
  isTeam = false,
  companyId = null,
  showMapping = true
}) => {
  const { user } = useAuth();
  const isRootUser = user?.company?.id === 1 && user?.company?.companyType === "GP";
  
  const { data: erpOptions } = useDropdown(
    isTeam ? "child_companies" : "companies",
    isTeam ? companyId : null,
    showMapping  
  );

  const handleERPChange = (e) => {
    setFieldValue("advance_settings.erp_company_id", e.target.value);
  };
  if (
    erpOptions &&
    values.advance_settings?.erp_company_id &&
    !erpOptions.some(
      (option) =>
        String(option.id) === String(values.advance_settings.erp_company_id)
    )
  ) {
    const { erp_company_id, erp_company_name } = values.advance_settings;
    erpOptions.push({
      id: String(erp_company_id),
      value: erp_company_name,
      is_active: true,
    });
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* Force Login from CRM */}
          {!isTeam && (
            <Grid item xs={12} className="enable-features__switch">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography>Force Login from CRM</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    {...getFieldProps("advance_settings.enforce_crm_user_only")}
                    checked={
                      values?.advance_settings?.enforce_crm_user_only || false
                    }
                    onChange={(e) =>
                      setFieldValue(
                        "advance_settings.enforce_crm_user_only",
                        e.target.checked
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* Restrict Charger Visibility */}
          {!isTeam && (
            <Grid item xs={12} className="enable-features__switch">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography>Restrict Charger Visibility</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    {...getFieldProps(
                      "advance_settings.restrict_charger_visibility"
                    )}
                    checked={
                      values?.advance_settings?.restrict_charger_visibility ||
                      false
                    }
                    onChange={(e) =>
                      setFieldValue(
                        "advance_settings.restrict_charger_visibility",
                        e.target.checked
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {/* Allow Other CPO Chargers */}
          {!isTeam && (
            <Grid item xs={12} className="enable-features__switch">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography>Allow Other CPO Chargers</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    {...getFieldProps(
                      "advance_settings.allow_other_cpo_chargers"
                    )}
                    checked={
                      values?.advance_settings?.allow_other_cpo_chargers ||
                      false
                    }
                    onChange={(e) =>
                      setFieldValue(
                        "advance_settings.allow_other_cpo_chargers",
                        e.target.checked
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {!isTeam && (
            <Grid item xs={12} className="enable-features__switch">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography>
                    Allow Manual Balance Edit for Parent RFID Tags
                  </Typography>
                </Grid>
                <Grid item>
                  <Switch
                    {...getFieldProps(
                      "advance_settings.allow_manual_balance_edit"
                    )}
                    checked={
                      values?.advance_settings?.allow_manual_balance_edit ||
                      false
                    }
                    onChange={(e) =>
                      setFieldValue(
                        "advance_settings.allow_manual_balance_edit",
                        e.target.checked
                      )
                    }
                    color="primary"
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      {/* New CMS/ERP COMPANY MAPPING section */}
      {showMapping && isRootUser && <Grid container spacing={2} sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" className="mb-2">
            CMS/ERP {isTeam ? "CHILD COMPANY" : "COMPANY"} MAPPING
          </Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth size="small">
            <InputLabel id="erp-company-mapping-label">
              ERP Company
            </InputLabel>
            {<Select
              labelId="erp-company-mapping-label"
              id="erp-company-mapping"
              key={values?.advance_settings?.erp_company_id || "initial"}
              label="ERP Company"
              disabled={
                !isCreateCompany && values?.advance_settings?.erp_company_id
              }
              value={values?.advance_settings?.erp_company_id || ""}
              onChange={handleERPChange}
              {...getFieldProps("advance_settings.erp_company_id")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {erpOptions &&
                erpOptions.map((option) => (
                  <MenuItem key={String(option.id)} value={String(option.id)}>
                    {option.value}
                  </MenuItem>
                ))}
            </Select>}
          </FormControl>
        </Grid>
      </Grid>}
    </>
  );
};

export default CompanyEnableFeatures;
